import { useTranslation } from "react-i18next";
import type { ProjectBoardView } from "../../../hooks/useCrossProjectBoard";
import ProjectOverviewCard from "./ProjectOverviewCard";

interface Props {
  projectBoards: ProjectBoardView[];
  onSelectProject: (projectId: number) => void;
}

export default function ProjectOverviewGrid({ projectBoards, onSelectProject }: Props) {
  const { t } = useTranslation("BoardPage");

  if (projectBoards.length === 0) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-body-regular-md content-base-low">{t("overview.emptyState")}</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
      {projectBoards.map((board) => (
        <ProjectOverviewCard
          key={board.project.id}
          project={board.project}
          onClick={() => onSelectProject(board.project.id)}
        />
      ))}
    </div>
  );
}
